import moment from 'moment'

import ColourMixin from '@/mixins/colour'
import { TaskStatusTypes, TaskItemTypes } from '@/store/types'

export default {
  mixins: [ColourMixin],
  methods: {
    orderItemDescription(orderItem) {
      return (orderItem.description + ' ' + (orderItem.generatedDescription || '')).trim()
    },
    isTaskActivePending(task) {
      return task.status == TaskStatusTypes.ready
    },

    colourForTask(task) {
      if(this.isColourLight(task.highlightColour))
        return this.darkenColour(task.highlightColour, 45)
      return this.lightenColour(task.highlightColour, 55)
    },
    borderColourForTask(task) {
      if(task.status == TaskStatusTypes.cancelled)
        return this.backgroundColourForTask(task)
        
      if(this.isColourLight(task.highlightColour))
        return this.darkenColour(task.highlightColour, 35)
      return this.darkenColour(task.highlightColour, 15)
    },
    backgroundColourForTask(task) {
      return task.highlightColour
    },
    classForTask(task) {
      if(task.status == TaskStatusTypes.cancelled)
        return ['task-status-cancelled']
      return []
    },

    taskStatusIcon(status) {
      switch(status) {
        case TaskStatusTypes.ready: return 'fa-dot-circle'
        case TaskStatusTypes.completed: return 'fa-check-circle'
        case TaskStatusTypes.cancelled: return 'fa-times-circle'
      }
      return ''
    },
    taskItemIcon(taskItem) {
      switch(taskItem.type) {
        case TaskItemTypes.general:
          return 'fa-clipboard-list-check'
        case TaskItemTypes.stoppage:
          return 'fa-stopwatch'
        case TaskItemTypes.orderDespatch:
          if(taskItem.isLocationEnabled)
            return 'fa-truck'
          return 'fa-person-dolly'
        default:
          return 'fa-clipboard-list-check'
      }
    },

    // DEPRECATED: Icon colours match foreground text colour for viewability
    taskStatusIconClass(status) {
      switch(status) {
        case TaskStatusTypes.ready: return 'status-task-pending'
        case TaskStatusTypes.completed: return 'status-task-completed'
        case TaskStatusTypes.cancelled: return 'status-task-cancelled'
      }
      return ''
    },
    taskStatusIconStack(status) {
      switch(status) {
        case TaskStatusTypes.ready: return ''
        case TaskStatusTypes.completed: return 'fa-circle'
        case TaskStatusTypes.cancelled: return 'fa-circle'
      }
      return ''
    },
    taskStatusIconStyle(status) {
      switch(status) {
        case TaskStatusTypes.ready: return 'fas'
        case TaskStatusTypes.completed: return 'fas'
        case TaskStatusTypes.cancelled: return 'fas'
      }
      return 'fas'
    }
  }
}